import { apiClient } from '@/services/apiClient';
import { Artist } from '../types';

export const listArtists = async (skip = 0, take = 24, opts?: { q?: string | undefined; genre?: string | undefined }): Promise<{ items: Artist[] }> => {
  const qs = new URLSearchParams({ skip: String(skip), take: String(take) });
  if (opts?.q) qs.set('q', opts.q);
  if (opts?.genre) qs.set('genre', opts.genre);
  const response = await apiClient.get<{ items: Artist[] }>(`/artists?${qs.toString()}`);
  return response;
};

export const getArtistById = async (id: string): Promise<Artist> => {
  const response = await apiClient.get<Artist>(`/artists/${id}`);
  return response;
};

export const createArtist = async (artist: Omit<Artist, 'id'>): Promise<Artist> => {
  const response = await apiClient.post<Artist>('/artists', artist);
  return response;
};

export const updateArtist = async (id: string, artist: Partial<Omit<Artist, 'id'>>): Promise<Artist> => {
  const response = await apiClient.patch<Artist>(`/artists/${id}`, artist);
  return response;
};

export const deleteArtist = async (id: string): Promise<void> => {
  await apiClient.delete(`/artists/${id}`);
};

export const autofillArtistByInput = async (spotifyUrl: string): Promise<Omit<Artist, 'id'>> => {
  const response = await apiClient.post<Omit<Artist, 'id'>>('/artists/autofill', { spotifyUrl });
  return response;
};
